<template>
      <!-- // frame usado para mostrar o tutorial da tela de tarefas -->
    <v-dialog full-width :value="true" scrollable persistent :width="$vuetify.breakpoint.smAndDown ? '100%' : '950px'">
      <!-- :style="$vuetify.breakpoint.smAndDown ? 'width: 100%!important; height: 100%!important;' : 'width: 60%!important; height: 90%!important;'" -->
      <v-card justify-center>
        <v-card-title>
          <v-icon color="teal" style="padding: 5px;" large>people</v-icon>
          <span :class="$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1'"><strong>Seja bem vindo!</strong></span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding-bottom: 0px;" >
          <v-layout fill-height>
            <v-flex class="text-xs-center">
              <v-form v-model="valid" ref="form" class="mb-1" style="overflow: auto; max-height: 350px" id="cardText">
                <v-layout row justify-start align-center wrap>
                  <v-flex xs12 class="flex_field">
                    <v-text-field required prepend-icon="person" name="name" label="Seu nome*" type="text" autofocus
                    :rules="requiredRule('Nome')"
                    v-model="user.id_text"
                    @blur="saveRegisterComplement({user_id_text: user.id_text})"
                    />
                  </v-flex>
                  <v-flex xs12 class="flex_field">
                    <v-text-field required prepend-icon="business" name="company_id_text" label="Nome da empresa*" type="text"
                      :rules="requiredRule('Nome da empresa')"
                      v-model="company.id_text"
                      @blur="saveRegisterComplement({id_text: company.id_text})"
                    />
                  </v-flex>
                  <v-flex xs12 class="flex_field" v-if="user.id_text !== '' && company.id_text !== ''">
                    <v-select
                    :rules="requiredRule('Segmento')"
                    :items="translate('value.company_segments')"
                    label="Segmento*"
                    item-value="segment_id"
                    item-text="id_text"
                    required prepend-icon="work" 
                    return-object
                    name="company_segments" 
                    v-model="company.segment"
                    @blur="saveRegisterComplement({segment: company.segment})"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 class="flex_field" v-if="company.segment.hasOwnProperty('segment_id') && company.segment['segment_id'] === 0 && user.id_text !== '' && company.id_text !== ''">
                    <v-text-field prepend-icon="work" 
                    :rules="requiredRule('Segmento')"
                    name="company_id_text_other" label="Qual segmento da sua empresa?*" type="text"
                    v-model="otherSegment"
                    @blur="saveRegisterComplement({segment: company.segment})"
                    />
                  </v-flex>
                  <v-flex xs12 class="flex_field" v-if="company['segment'].hasOwnProperty('segment_id')">
                    <v-select
                    :rules="requiredRule('Tamanho')"
                    :items="translate('value.company_size')"
                    label="Qual o tamanho da sua equipe?*"
                    required prepend-icon="work" 
                    name="company_size" 
                    v-model="user_tracking.company_size"
                    @change="saveRegisterComplement({company_size: user_tracking.company_size})"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 class="flex_field" v-if="user_tracking['company_size'] != ''">
                    <v-select
                      v-if="$vuetify.breakpoint.smAndDown"
                      :rules="requiredManyRule('Busca')"
                      multiple
                      return-object
                      chips
                      :items="translate('value.company_search')"
                      label="O que você busca?*"
                      required prepend-icon="work" 
                      name="company_search"
                      item-value="search_id"
                      item-text="id_text"
                      :menu-props="{'closeOnContentClick':true}"
                      v-model="company['search']"
                      @change="scrollDown()"
                    ></v-select>
                    <div v-else>
                      <!-- <h4>Selecione o que você busca*</h4> -->
                      <v-item-group multiple v-model="company['search']" v-if="user_tracking['company_size'] != ''" return-object>
                        <v-subheader>Selecione o que você busca*</v-subheader>
                        <v-item
                          v-for="(item, index) in itemsSearch"
                          :key="index"
                          :value="item"
                        >
                          <v-chip
                            slot-scope="{ active, toggle }"
                            @click="toggle"
                            outline color="primary"
                            :selected="active"
                          >
                            <v-checkbox @click="scrollDown()" readonly :value="active" color="primary" class="mx-auto" style="padding-top:10px"></v-checkbox>
                            <span @click="scrollDown()">
                              {{item['id_text']}}
                            </span>
                          </v-chip>
                        </v-item>
                      </v-item-group>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="flex_field" v-if="company['search'].some((val) => val['search_id'] === 0) && user_tracking.hasOwnProperty('company_size')">
                    <v-text-field prepend-icon="work"
                    :rules="requiredRule('Busca')"
                    name="company_search_other" label="Descreva o que você busca*" type="text"
                    v-model="otherSearch"
                    />
                  </v-flex>
                  <v-flex xs12 class="text-xs-left">
                    <small class="required-field">* indica campos obrigatórios</small>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center" v-if="company['search'] != '' && company['search'] != []">
                    <v-btn round color="primary" dark @click="next()">Finalizar cadastro</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
            <v-flex class="text-xs-center" v-if="!$vuetify.breakpoint.smAndDown" width="300px">
              <img class="loader" :src="`${basePath}images/complement_register.gif`" width="300px"/>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
  /* eslint-disable no-unneeded-ternary */
  import rules from '../../mixin/rules'

  export default {
    name: 'PRegisterComplement',
    mixins: [rules],
    props: [],
    data: () => ({
      basePath: process.env.API,
      valid: false,
      otherSegment: null,
      otherSearch: null,
      itemsSearch: [],
      company: {
        id_text: '',
        segment: '',
        search: []
      },
      user: {
        id_text: ''
      },
      user_tracking: {
        company_size: ''
      }
    }),
    created () {
      this.itemsSearch = this.translate('value.company_search')
    },
    methods: {
      // desce a barra de rolagem
      scrollDown () {
        setTimeout(() => {
          var cardText = document.getElementById('cardText')
          console.log('cardText', cardText)
          cardText.scrollTop = cardText.scrollHeight
        }, 1000)
      },
      next () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, preencha todos os campos antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // quando clicar em prosseguir salvar o ultimo valor que seria o do busca
        this.saveRegisterComplement({search: this.company['search']})
        this.$emit('next')
      },
      saveRegisterComplement (values) {
        let checkValidation = true
        if (values.hasOwnProperty('user_id_text')) {
          checkValidation = values['user_id_text'] === ''
        } else
        if (values.hasOwnProperty('id_text')) {
          checkValidation = values['id_text'] === ''
        } else
        // verificar se foi selecionado o segmento outros, se for pega o valor do campo referente ao outro segmento para adiciona-lo no banco
        if (values.hasOwnProperty('segment')) {
          if (values['segment'].hasOwnProperty('segment_id')) {
            if ((parseInt(values['segment']['segment_id']) === 0) && (this.otherSegment !== '' && this.otherSegment !== null)) {
              this.company['segment']['id_text'] = this.otherSegment
            }
            checkValidation = false
          }
        } else
        // verificar se foi selecionado na busca, outros, se for pega o valor do campo referente a descrição do que foi buscado para adiciona-lo no banco
        if (values.hasOwnProperty('search')) {
          if (values['search'].length > 0) {
            let otherSearch = values['search'].find(val => val['search_id'] === 0)
            if ((otherSearch) && this.otherSearch !== '' && this.otherSearch !== null) {
              otherSearch['id_text'] = this.otherSearch
            }
            checkValidation = false
          }
        } else
        if (values.hasOwnProperty('company_size')) {
          checkValidation = false
        }
        this.scrollDown()
        values['company_id'] = this.$auth.user()['company_id']
        if (!checkValidation) {
          this.$http.post(`api/register_complement`, values).then(res => {
            // Caso seja alteração no nome do usuário ou da empresa, já altera no front
            if (values.hasOwnProperty('user_id_text')) {
              this.$auth.user()['id_text'] = values['user_id_text']
            } else if (values.hasOwnProperty('id_text')) {
              this.$auth.user().company['id_text'] = values['id_text']
            }
          }, err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível salvar o nome da empresa, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PRegisterComplement.vue